module.exports = __webpack_public_path__ + "img/banner.8f8dda4b.jpeg";